export default __webpack_public_path__ + "static/O0188-b88da858c5288d4c72b7b9f7588e35f2.png";